<template>
  <div class="consultingServicePage">
    <v-topBar :yellowPageColumn='yellowPageColumn'
              :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-topBar>
    <v-header class="hidden-xs hidden-sm"
              :navigationColumnInfos='navigationColumnInfos'
              :webConfigInfo='webConfigInfo'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-header>
    <el-row>
      <el-col :span="24">
        <div class="bgImg" @click="linkUrl" style="cursor: pointer;"></div>
        <div class="partTwo">
          <v-publiceTit :titleObj='titleObj'></v-publiceTit>
          <div class="introduce">
            <p>一链网供应商增值服务能为您带来什么?</p>
            <p>为给供应商企业带来更优质的体验，一链网特别推出供应商专业版服务，开通即享尊贵待遇，收获丰盛福利：</p>
          </div>
          <ul class="row clearfix">
            <li class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                v-for="(item, index) in o" :key="index">
              <div class="clearfix">
                <span class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                  <img :src="item.src" alt="">
                </span>
                <div class="supplierManageLiCon col-xs-9 col-sm-9 col-md-9 col-lg-9">
                  <h3>{{item.h}}</h3>
                  <p class="desc">{{item.desc}}</p>
                </div>
              </div>
            </li>
          </ul>
          <p class="more">.....更多福利等您解锁</p>
        </div>
        <div class="partThree">
          <v-publiceTit :titleObj='titleObjrisk' class="titleObjrisk"></v-publiceTit>
          <p style="max-width: 1200px; margin: auto; padding:0 12px;" @click="$router.push('creditReport')">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E4%B8%80%E9%93%BE%E7%BD%91%E9%87%87%E8%B4%AD%E5%92%A8%E8%AF%A2%E6%9C%8D%E5%8A%A1.jpg" width="100%">
          </p>
        </div>
      </el-col>
    </el-row>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>

<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
import publiceTit from '@/components/publiceTit'


export default {
  name: '',
  data () {
    return {
      yellowPageColumn: {},
      productAndSolutionColumn: {},
      hitSearchUrl: '',
      enterpriseResourceBaseUrl: '',
      navigationColumnInfos: [],
      webConfigInfo: {},
      footerColumnInfos: [],
      o: [
        {
          src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/authoritative.jpg',
          h: '第三方征信机构权威认证',
          desc: '权威征信机构为企业出示信用报告，提升企业信用背书，享受征信'
        },
        {
          src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/buiness.jpg',
          h: '商机服务',
          desc: '精准匹配商机，锁定目标客户，不错漏任何商机'
        },
        {
          src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/homepage.jpg',
          h: '专业版企业主页',
          desc: '定制企业页面，区别于普通用户，彰显尊贵身份'
        },
        {
          src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/sort.jpg',
          h: '排序优先',
          desc: '同等搜索条件下，由于基础企业版用户排名，增加企业曝光机会'
        }
      ],
      tableData: [{
        title: '在线投标',
        name: '公开招标项目报名'
      }, {
        name: '公开询报价报名'
      }, {
        name: '收藏招标公告'
      }, {
        title: '商机服务',
        name: '商机推送'
      }, {
        name: '优先推送给采购方',
        flag: '0'
      }, {
        name: ' '
      }, {
        title: '征信认证',
        name: '征信级别徽章',
        flag: '0'
      }, {
        name: '第三方征信报告',
        flag: '0'
      }, {
        name: ''
      }, {
        title: '增值服务',
        name: 'VIP徽章',
        flag: '0'
      }, {
        name: '资源大厅搜索排名靠前',
        flag: '0'
      }, {
        name: '资源大厅企业主页'
      }, {
        title: '',
        name: ''
      }],
      titleObj: {name: '核心价值', eng: 'SUPPLIER ENTRY'},
      titleObjrisk: {name: '服务与价格', eng: 'SUPPLIER ENTRY'},
      purchaseUrl: ''
    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-footer': footer,
    'v-backToTop': backToTop,
    'v-publiceTit': publiceTit
  },
  created () {
    this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
    }).then((res) => {
      this.data = res.data;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    }).catch((err) => {
      console.log(err)
    })
  },
  mounted () {
    this.getUrl()
  },
  methods: {
    getUrl () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findPaltformMapInfo', {
      }).then((res) => {
        this.purchaseUrl = res.data.creditPurchaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    linkUrl () {
      window.location.href = this.purchaseUrl;
    }
  }
}
</script>

<style lang="stylus" scoped>
  .bgImg {
    width: 100%;
    height: 240px;
    position: relative;
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E4%BD%8D%E5%9B%BE.png') no-repeat center top;
    background-size: cover;
  }
  @media (max-width: 768px)
    .bgImg {
      height: 120px;
    }
.partTwo,.partThree{
  text-align: center;
  padding: 40px 0;
}
.partTwo {
  font-family: PingFangSC-Regular;
  .introduce {
    font-size: 16px;
    color: #303133;
    text-align: center;
    line-height: 36px;
    margin: 30px 0;
    padding: 0 15px;
  }
  h3 {
    font-family: PingFangSC-Medium;
    font-size: 24px;
  }
  .desc {
    font-size: 14px;
    color: #606266;
    line-height: 24px;
  }
  .more {
    font-size: 16px;
    color: #909399;
    text-align: center;
  }
}

.partThree {
  background: url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/price.jpg");
}
.row {
  max-width: 1200px;
  margin: auto;
  li {
    margin-bottom: 48px;
    >div{
      background: #FFFFFF;
      box-shadow: 0 0 16px 0 rgba(0,0,0,0.10);
      padding: 25px;
     img {
       max-width: 100%;
     }
      span {
        padding: 0;
        display: inline-block;
      }
      h3 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      div {
        text-align: left;
      }
    }
  }
}
@media screen and (max-width: 360px){
  h3 {
    margin-top: 0;
  }
}
</style>
<style lang="stylus">
  .titleObjrisk {
    margin-bottom: 30px;
  }
  .titleObjrisk .title{
  .titleBg , .titleCon{
    color: #fff;
  }
  .line{
    background: #fff;
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/supplierService/index.vue